import React from 'react'
import { TextRegular } from '../../styles/GlobalStyledComponents'
import { ErrorCardImg, ErrorMsgImgWrapper, ErrorMsgWrapper, ErrorWrapper } from './ErrorMessageStyledComponents'
import CardError from '../../assets/images/Header/CardError.svg';

const ErrorMessage = () => {
  return (
    <ErrorWrapper>
      <ErrorMsgWrapper>
        <ErrorMsgImgWrapper>
          <ErrorCardImg src={CardError} alt="Error Icon" />
        </ErrorMsgImgWrapper>
        <TextRegular fontSize={14} fontWeight={500} color='alertErrorPrimary'>¡Vaya! No hemos podido realizar el cargo. Selecciona otra forma de pago.</TextRegular>
      </ErrorMsgWrapper>
    </ErrorWrapper>
  )
}

export default ErrorMessage